import { useQuery } from '@tanstack/react-query';

import { getLereAdSpendHistory } from '~/services/PublicOfferFeedService';

export const lereAdSpendHistoryQueryKeys = {
  all: ['googleAds', 'lereAdSpendHistory'] as const,
  lists: () => [...lereAdSpendHistoryQueryKeys.all, 'list'] as const,
  list: (filters: { customerId: string; campaignId: string; adGroupId: string; startDate: string; endDate: string }) =>
    [...lereAdSpendHistoryQueryKeys.lists(), filters] as const,
};

export function useGetLereAdSpendHistory({
  customerId,
  campaignId,
  adGroupId,
  startDate,
  endDate,
  enabled = true,
}: {
  customerId: string;
  campaignId: string;
  adGroupId: string;
  startDate: string;
  endDate: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: lereAdSpendHistoryQueryKeys.list({ customerId, campaignId, adGroupId, startDate, endDate }),
    queryFn: async ({ signal }) => {
      return await getLereAdSpendHistory({ customerId, campaignId, adGroupId, startDate, endDate }, { signal });
    },
    enabled: enabled && Boolean(customerId && campaignId && adGroupId && startDate && endDate),
  });
}
